import { DropdownSelect } from "@vds/selects";
import { Body } from "@vds/typography";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSitesAndFloorsData } from "../../utility/Utils";

const SitesDropdownFilter = ({
  filters,
  activeTab,
  selectedOptions,
  handleFilterChange,
  dataList,
  setSitesDropdownFlow,
  pageIdentifier,
  getSelectedRolesReset,
  getIsValidDataReset,
  companionSiteId = null,
}) => {
  const [siteList, setSiteList] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [selectedSiteId, setSelectedSiteId] = useState(companionSiteId || "");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const [allFloors, setAllFloors] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const locationList = getSitesAndFloorsData(siteTagList);
  const allAreas = locationList.areas;
  let showFloorAndArea;
  if (pageIdentifier === "CompanionTab") {
    showFloorAndArea = false;
  } else {
    showFloorAndArea = true;
  }
  const isSiteDisabled = Boolean(companionSiteId);

  let filteredSites = siteList || [];
  const handleSiteToggle = (selectedSiteId, filteredSites) => {
    setSelectedSiteId(selectedSiteId);
    setSelectedFloor(""); // Clear selected floor when site changes
    setSelectedAreaId(""); // Clear selected area when site changes
    const selectedSite = filteredSites.find(
      (site) => site.id === selectedSiteId
    );
    if (selectedSite) {
      setSelectedSites(selectedSite);
      setIsValid(true);
      getIsValidDataReset(false);
    } else {
      setSelectedSites([]);
      setIsValid(false);
    }
  };

  const handleFloorChange = (selectedFloorId) => {
    setSelectedFloor(selectedFloorId);
    setSelectedAreaId(""); // Clear selected area when floor changes
    const selectedFloor = allFloors.find(
      (floor) => floor.id === selectedFloorId
    );
    return selectedFloor;
  };

  useEffect(() => {
    if (getSelectedRolesReset) {
      setSelectedSites([]);
      setSelectedSiteId("");
      setSelectedFloor("");
    }
  }, [selectedSiteId, selectedFloor, getSelectedRolesReset]);

  useEffect(() => {
    if (selectedSiteId) {
      const floorData = siteTagList?.floors.filter((f) => {
        try {
          return f.tagids && selectedSiteId.indexOf(f.tagids[0]) > -1;
        } catch (error) {
          return false;
        }
      });
      if (floorData.length) {
        setAllFloors(floorData.flat());
      }
      if (selectedFloor) {
        const filterAreas = allAreas.filter((area) => {
          return area?.tagids?.includes(selectedFloor);
        });
        setFilteredAreas(filterAreas);
        if (filteredAreas.length) {
          setFilteredAreas(filterAreas.flat());
        }
      }
    }
  }, [selectedSiteId, selectedFloor]);

  useEffect(() => {
    setSiteList(siteTagList?.sites);
    setSitesDropdownFlow(true);
  }, []);
  useEffect(() => {
    if (companionSiteId && siteTagList?.sites?.length > 0) {
      const selectedSite = siteTagList.sites.find(
        (site) => site.id === companionSiteId
      );
      if (selectedSite) {
        setSelectedSites(selectedSite);
        handleFilterChange(activeTab, { value: `site_${companionSiteId}` });
      }
    }
  }, [companionSiteId]);

  // Initialize selected values from selectedOptions
  useEffect(() => {
    if (selectedOptions?.Location && pageIdentifier === "Events") {
      const locationData = selectedOptions.Location;
      if (locationData.siteid) {
        setSelectedSiteId(locationData.siteid);
        const selectedSite = siteTagList?.sites?.find((site) => site.id === locationData.siteid);
        if (selectedSite) {
          setSelectedSites(selectedSite);
        }
      }
      if (locationData.floorid) {
        setSelectedFloor(locationData.floorid);
      }
      if (locationData.areaid) {
        setSelectedAreaId(locationData.areaid);
      }
    }
    if (
      selectedOptions?.Location &&
      (pageIdentifier === "CamerasTab" || pageIdentifier === "CompanionTab" || pageIdentifier === "Alerts") &&
      Array.isArray(selectedOptions.Location)
    ) {
      const locationTokens = selectedOptions.Location;
      const siteToken = locationTokens.find((t) => t.startsWith("site_"));
      const floorToken = locationTokens.find((t) => t.startsWith("floor_"));
      const areaToken = locationTokens.find((t) => t.startsWith("area_"));

      const siteId = siteToken ? siteToken.replace("site_", "") : "";
      const floorId = floorToken ? floorToken.replace("floor_", "") : "";
      const areaId = areaToken ? areaToken.replace("area_", "") : "";

      if (siteId) {
        setSelectedSiteId(siteId);
        const selectedSite = siteTagList?.sites?.find((site) => site.id === siteId);
        if (selectedSite) {
          setSelectedSites(selectedSite);
        }
      }
      if (floorId) {
        setSelectedFloor(floorId);
      }
      if (areaId) {
        setSelectedAreaId(areaId);
      }
    }
  }, [selectedOptions, pageIdentifier, siteTagList]);

  return (
    <div>
      <div
        style={{
          marginBottom: "30px",
          width: "100%",
        }}
      >
        <DropdownSelect
          label="Select site"
          width="100%"
          value={selectedSiteId || ""}
          onChange={(e) => {
            if (!isSiteDisabled) {
              handleSiteToggle(e.target.value, filteredSites);
              handleFilterChange(activeTab, { value: `site_${e.target.value}` });
            }
          }}
          readOnly={isSiteDisabled}
          disabled={isSiteDisabled}
        >
          <option value="">All(default)</option>
          {filteredSites?.length > 0 && Array.isArray(filteredSites) ? (
            filteredSites.map((site, index) => (
              <option key={site.id + "" + index} value={site.id}>
                {site?.title || site?.name}
              </option>
            ))
          ) : (
            <option value="">No Sites Available</option>
          )}
        </DropdownSelect>
        {showFloorAndArea && (
          <div>
            {selectedSiteId.length > 0 ? (
              <div style={{ paddingTop: "20px" }}>
                <div style={{ paddingBottom: "10px" }}>
                  <Body size="large" bold>
                    Floor
                  </Body>
                </div>
                <DropdownSelect
                  label="Select floor"
                  value={selectedFloor || ""}
                  onChange={(e) => {
                    handleFloorChange(e.target.value);
                    handleFilterChange(activeTab, {
                      value: `floor_${e.target.value}`,
                    });
                  }}
                  readOnly={false}
                  required={true}
                  inlineLabel={false}
                  width="100%"
                >
                  <option></option>
                  {allFloors &&
                    allFloors.map((floor, index) => (
                      <option
                        //   selected={floorSelected?.id === floor?.id}
                        key={floor.id + "" + index}
                        value={floor.id}
                      >
                        {floor.name}
                      </option>
                    ))}
                </DropdownSelect>
              </div>
            ) : (
              <div style={{ paddingTop: "20px" }}>
                <Body size="large" bold>
                  Floor
                </Body>
                <div style={{ paddingTop: "20px" }}>
                  <Body size="large" color="#6F7171">
                    You must first select a site in order to select a floor.
                  </Body>
                </div>
              </div>
            )}
            {selectedFloor?.length > 0 ? (
              <div style={{ paddingTop: "20px" }}>
                <Body size="large" bold>
                  Area
                </Body>
                {filteredAreas?.map((option, index) => (
                  <div
                    key={option.id + "" + index}
                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                  >
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectedAreaId === option.id}
                        onChange={() => {
                          setSelectedAreaId(selectedAreaId === option.id ? "" : option.id);
                          handleFilterChange(activeTab, {
                            value: `area_${option.id}`,
                          });
                        }}
                        style={{
                          marginRight: "10px",
                          width: "20px",
                          height: "20px",
                          borderColor: "#6F7171",
                        }}
                      />
                      <Body size="medium">{option.name}</Body>
                    </label>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ paddingTop: "20px" }}>
                <Body size="large" bold>
                  Area
                </Body>
                <div style={{ paddingTop: "20px" }}>
                  <Body size="large" color="#6F7171">
                    You must first select a floor in order to select an area.
                  </Body>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default SitesDropdownFilter;
